<template>
  <div>
    <v-container fluid class="center-align">
      <v-radio-group row v-model="radios" :mandatory="false">
        <v-radio label="Original docs" value="original_docs"></v-radio>
        <v-radio label="DE Docs" value="de_docs"></v-radio>
      </v-radio-group>
    </v-container>
    <v-flex xs12 style="height: 14rem;" v-if="radios=='original_docs'">
      <v-layout row wrap>
        <v-flex xs12>
          <v-row
            class="statusTabLine">
            <v-col
              cols="12"
              sm="12"
              class="d-flex align-center"
            >
              <div v-for="item in tabs" v-bind:key="item.id" class="statusLineIcons">
                <v-btn flat v-bind:class="['statusTab', {activeStatusTab: item.name==activeTab.name }]" @click="changeTab(item)">
                  <span v-if="item.name=='Taxes'">
                    {{taxesPackages.length}}
                  </span>
                  <span v-if="item.name=='Deeds'">
                    {{deedsPackages.length}}
                  </span>
                  <span v-if="item.name=='Invol Liens'">
                    {{involLiensPackages.length}}
                  </span>
                  <span v-if="item.name=='Mortgages'">
                    {{mortgagesPackages.length}}
                  </span>
                  <span v-if="item.name=='Others'">
                    {{othersPackages.length}}
                  </span>
                </v-btn>
                <br />
                <v-btn style="margin-top: 1.5rem;">
                  {{item.name}}
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 v-if="activeTab.name=='Taxes'">
          <v-tooltip bottom v-for="pkg in taxesPackages" v-bind:key="pkg.id">
            <template v-slot:activator="{ on }">
              <v-chip
                class="ma-2"
                color="primary"
                label
                v-on="on" @click="loadPDF(pkg.package)"
              >
                <v-icon left>picture_as_pdf</v-icon>
                {{ pkg.package.name }}
              </v-chip>
            </template>
            <span>{{ pkg.package.file }}</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 v-if="activeTab.name=='Deeds'">
          <v-tooltip bottom v-for="pkg in deedsPackages" v-bind:key="pkg.id">
            <template v-slot:activator="{ on }">
              <v-chip
                class="ma-2"
                color="primary"
                label
                v-on="on" @click="loadPDF(pkg.package)"
              >
                <v-icon left>picture_as_pdf</v-icon>
                {{ pkg.package.name }}
              </v-chip>
            </template>
            <span>{{ pkg.package.file }}</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 v-if="activeTab.name=='Mortgages'">
          <v-tooltip bottom v-for="pkg in mortgagesPackages" v-bind:key="pkg.id">
            <template v-slot:activator="{ on }">
              <v-chip
                class="ma-2"
                color="primary"
                label
                v-on="on" @click="loadPDF(pkg.package)"
              >
                <v-icon left>picture_as_pdf</v-icon>
                {{ pkg.package.name }}
              </v-chip>
            </template>
            <span>{{ pkg.package.file }}</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 v-if="activeTab.name=='Invol Liens'">
          <v-tooltip bottom v-for="pkg in involLiensPackages" v-bind:key="pkg.id">
            <template v-slot:activator="{ on }">
              <v-chip
                class="ma-2"
                color="primary"
                label
                v-on="on" @click="loadPDF(pkg.package)"
              >
                <v-icon left>picture_as_pdf</v-icon>
                {{ pkg.package.name }}
              </v-chip>
            </template>
            <span>{{ pkg.package.file }}</span>
          </v-tooltip>
        </v-flex>
        <v-flex xs12 v-if="activeTab.name=='Others'">
          <v-tooltip bottom v-for="pkg in othersPackages" v-bind:key="pkg.id">
            <template v-slot:activator="{ on }">
              <v-chip
                class="ma-2"
                color="primary"
                label
                v-on="on" @click="loadPDF(pkg.package)"
              >
                <v-icon left>picture_as_pdf</v-icon>
                {{ pkg.package.name }}
              </v-chip>
            </template>
            <span>{{ pkg.package.file }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12 style="height: 14rem;" v-else>
      <v-layout row wrap>
        <v-flex xs12>
          <v-tooltip bottom v-for="pkg in dataEntryPackages" v-bind:key="pkg.id">
            <template v-slot:activator="{ on }">
              <v-chip
                class="ma-2"
                color="primary"
                label
                v-on="on" @click="loadPDF(pkg.package)"
              >
                <v-icon left>picture_as_pdf</v-icon>
                {{ pkg.package.name }}
              </v-chip>
            </template>
            <span>{{ pkg.package.file }}</span>
          </v-tooltip>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex xs12>
      <v-container
        id="scroll-target"
        class="scroll-y"
        style="max-height: 850px; min-height: 850px; overflow: auto;padding: 0.2rem;border: solid 7px #636060;background: #636060;"
      >
        <!-- <pdf
          :src="pdfdata"
          v-for="i in numPages"
          :key="i"
          :id="i"
          :page="i"
          :scale.sync="scale"
        >
          <template slot="loading">loading content here...</template>
        </pdf> -->
        <pdfJSViewer :pdfURL="pdfURL"> </pdfJSViewer>
      </v-container>
    </v-flex>
  </div>
</template>

<script>
import pdfJSViewer from '@/components/pdfViewerJS.vue'
import {
  GETORDERPACKAGELISTBYORDERID, GETPACKAGECATEGORIESLIST
} from '@/store/actions.type'

export default {
  name: 'pdfViewer',
  components: {
    pdfJSViewer
  },
  data () {
    return {
      page: 1,
      numPages: 0,
      pdfdata: undefined,
      errors: [],
      scale: 'page-width',
      tabs: undefined,
      activeTab: undefined,
      dataEntryPackages: [],
      taxesPackages: [],
      deedsPackages: [],
      mortgagesPackages: [],
      involLiensPackages: [],
      othersPackages: [],
      radios: 'original_docs'
    }
  },
  props: {
    pdfURL: null,
    syncPackages: null,
    syncTabs: null
  },
  mounted () {
    this.$store
      .dispatch(GETPACKAGECATEGORIESLIST)
      .then(response => {
        console.log(response)
        this.tabs = response.results
        this.activeTab = response.results[0]
      })
  },
  watch: {
    syncPackages: {
      immediate: true,
      handler (newVal, oldVal) {
        this.getPackages()
      }
    },
    syncTabs: {
      immediate: true,
      handler (newVal, oldVal) {
        let tab = null
        this.tabs.forEach((tb, index) => {
          if (tb.name.trim().toLowerCase() === this.syncTabs.trim().toLowerCase()) {
            tab = tb
          }
        })
        this.activeTab = tab
      }
    }
  },
  methods: {
    getPackages () {
      let payload = {
        order__id: this.$route.params.uid
      }
      this.$store
        .dispatch(GETORDERPACKAGELISTBYORDERID, payload)
        .then(response => {
          console.log(response)
          this.taxesPackages = []
          this.deedsPackages = []
          this.mortgagesPackages = []
          this.involLiensPackages = []
          this.othersPackages = []
          this.dataEntryPackages = []
          for (let i = 0; i < response.results.length; i++) {
            if (response.results[i].package.category) {
              if (response.results[i].package.category.name === 'Taxes' && response.results[i].status === 'Approved') {
                this.taxesPackages.push(response.results[i])
              } else if (response.results[i].package.category.name === 'Deeds' && response.results[i].status === 'Approved') {
                this.deedsPackages.push(response.results[i])
              } else if (response.results[i].package.category.name === 'Mortgages' && response.results[i].status === 'Approved') {
                this.mortgagesPackages.push(response.results[i])
              } else if (response.results[i].package.category.name === 'Invol Liens' && response.results[i].status === 'Approved') {
                this.involLiensPackages.push(response.results[i])
              } else if (response.results[i].package.category.name === 'Others' && response.results[i].status === 'Approved') {
                this.othersPackages.push(response.results[i])
              }
            }
            if (response.results[i].status === 'DataEntry') {
              this.dataEntryPackages.push(response.results[i])
            }
          }
        })
    },
    changeTab (tab) {
      this.activeTab = tab
    },
    loadPDF (pkg) {
      this.pdfURL = pkg.file
    }
  }
}
</script>

<style lang='css' scoped>
#buttons {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
/* Page content */
.content {
  padding: 16px
}

.statusTab {
    color: #fff !important;
    background-color: hsl(2, 64%, 58%) !important;
    border-color: hsl(2, 64%, 58%);
    width: 1rem;
    height: 3rem !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 6rem;
    font-size: 20px !important;
    font-weight: 900;
}
.statusTab:after {
    content:'';
    position: absolute;
    top: 100%;
    margin-left: -21%;
    width: 0;
    height: 0;
    border-top: solid 20px hsl(2, 64%, 58%);
    border-left: solid 15px transparent;
    border-right: solid 15px transparent;
}

.activeStatusTab {
    background-color: #00abab !important;
    border-color: #00abab !important;
    color: #fff !important;
    width: 1rem;
    height: 3rem !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 6rem;
    font-size: 20px !important;
    font-weight: 900;
}

.activeStatusTab:after {
    content:'';
    position: absolute;
    top: 100%;
    margin-left: -21%;
    width: 0;
    height: 0;
    border-top: solid 20px #00abab;
    border-left: solid 15px transparent;
    border-right: solid 15px transparent;
}
.v-btn--contained:after {
    -webkit-box-shadow: 0 2px 4px -1px rgba(0,0,0,.2), 0 4px 5px 0 rgba(0,0,0,.14), 0 1px 10px 0 rgba(0,0,0,.12);
    box-shadow: none;
}

.statusTabLine {
  width: 100%;
}

.statusTabLine:before {
    width: 90%;
    background: #00abab;
    content: "";
    height: 1px;
    position: relative!important;
    padding: 2px;
    top: 40px!important;
    left: 0!important;
    margin: auto;
    display: inline-block;
}
.center-align {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
